import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPrebookOrderList = createAsyncThunk(
  "get-prebook-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("pre-book-order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Options for the list's "Approved By" filter - only the people who have
// actually approved a pre-order.
export const getPrebookApprovers = createAsyncThunk(
  "get-prebook-approvers",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get("pre-book-order/approvers");
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createPrebookOrder = createAsyncThunk(
  "create-prebook-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("pre-book-order", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdPrebookOrder = createAsyncThunk(
  "edit-prebook-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`pre-book-order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updatePrebookOrder = createAsyncThunk(
  "update-prebook-order",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/pre-book-order/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const approvePrebookOrder = createAsyncThunk(
  "approve-prebook-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.patch(`/pre-book-order/${id}/approve`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const rejectPrebookOrder = createAsyncThunk(
  "reject-prebook-order",
  async ({ id, reason }, { dispatch }) => {
    try {
      const response = await axios.patch(`/pre-book-order/${id}/reject`, {
        reason,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getPrebookOrderTracking = createAsyncThunk(
  "get-prebook-order-tracking",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`/pre-book-order/${id}/tracking`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deletePrebookOrder = createAsyncThunk(
  "delete-prebook-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/pre-book-order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const prebookOrderSlice = createSlice({
  name: "prebookOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPrebookOrderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPrebookOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.prebookList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getPrebookOrderList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default prebookOrderSlice.reducer;
